import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Typography from '../../Generic/Typography';
import Rating from '../../Generic/Rating';
import urlProvider from '../../../utils/url-manager/urlProvider';
import cardStyles from './ProductCard-tw-styles';
import { getCdnImage as getImageUrl } from '../../../utils/ImageManager';
import { withLocale } from '../../Generic/LocaleProvider';
import BuyNowLiteComponent from '../../Generic/BuyNowLite';
import i18nMessages from '../../../constants/messages/pt-BR';
import DOMPurify from 'isomorphic-dompurify';
import { CardMedia, Card, CardContent } from '../../Generic/Card';

export class ProductCard extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }

  componentDidMount() {
    const isMobile = window.innerWidth < 767;
    this.setState({
      isMobile: isMobile,
    });
  }

  averageOverallRatingFormat = avgOverAllRating => {
   if(typeof(avgOverAllRating)=='string') return null;

    if (avgOverAllRating % 1 === 0) {
      return avgOverAllRating;
    } else {
      return avgOverAllRating?.toFixed(2);
    }
  };

  handlingvariants = data => {
    let pushData = [];
    data &&
      data.forEach(item => {
        let arr = item.split('|');
        pushData.push({
          name: arr[0],
          variantName: arr[1],
          gtin: arr[2],
        });
      });
    return pushData;
  };

  render() {
    const { cardType, productData, locale, indexKey, indexNo, lazyLoad } = this.props;
    const { isMobile } = this.state;
    const constants = require(`../../../constants/messages/${locale}`);
    let data = productData;
    const variants = this.handlingvariants(data.variantsgtin);
    const { rating: ratingData, ratingCount } = data;
    const overallRatingRange = 5;
    let cardTypestyle = (data && data.styles && data.styles.trim()) || cardType;
    if (cardStyles[cardTypestyle] === undefined) {
      cardTypestyle = cardType;
    }
    const mediaProps = {
      type: i18nMessages.img,
      src: data.image && data.image.url,
      alt: data.image && data.image?.description,
    };
    let widthClass = '';
    let cardMedia = '';
    const link = urlProvider(i18nMessages.productPage, locale, data.link);
    if (mediaProps.src) {
      cardMedia = (
        <CardMedia
          className={classNames(cardStyles['ListingCard'].cardMedia)}
          image={getImageUrl(mediaProps.src)}
          component={mediaProps.type}
          alt={mediaProps.alt ? mediaProps.alt : data.title}
          cardType={cardType}
          lazyLoad={lazyLoad}
          height={isMobile ? 89 : 95}
          width={isMobile ? 160 : 161}
        />
      );
    }

    let title = '';
    if (data.title) {
      title = (
        <Typography
          component="h3"
          className={cardStyles['ListingCard'].heading}
          dangerouslySetInnerHTML={{
            __html:DOMPurify.sanitize( data.title),
          }}
        />
      );
    }

    let titleMediaLink = '';

    let cardMediaLink = '';
    if (link.path) {
      cardMediaLink = (
        <a
          data-pgaction-redirection="0"
          href={link.path}
          className={classNames('event_image_link')}
          data-action="event_image_link"
          tabIndex={-1}
          aria-hidden="true"
        >
          {cardMedia}
        </a>
      );

      titleMediaLink = (
        <a
          data-pgaction-redirection="0"
          href={link.path}
          tabIndex={-1}
          className={classNames('', cardStyles.noUnderline, classNames)}
          aria-label={`${data.title || ''} - Ver detalhes do produto`}
        >
          {title}
        </a>
      );
    } else {
      cardMediaLink = cardMedia;
      titleMediaLink = title;
    }

    return (
      <>
        <Card
          key={indexKey}
          className={classNames(widthClass, cardStyles['ListingCard'].card)}
        >
          <div>
            {cardMediaLink}
            <CardContent>
              {true && (
                <div>
                  <Rating tabIndex={-1} rating={ratingData || 0} totalReviews={ratingCount || 0} />
                  <Typography
                    component="span"
                    className={cardStyles['ListingCard'].ratingTextCount}
                  >
                    {`${
                      ratingData ? this.averageOverallRatingFormat(ratingData) : 0
                    }/${overallRatingRange} (${ratingCount || 0})`}
                  </Typography>
                </div>
              )}
              {titleMediaLink}
            </CardContent>
          </div>
          {data.productCategoryType && (
            <Typography
              className={classNames(cardStyles['ListingCard'].description)}
              component="div"
              dangerouslySetInnerHTML={{
                __html:DOMPurify.sanitize( data.productCategoryType),
              }}
            />
          )}
          <div
            className={cardStyles.buyNowBtnWrapper}
            id={i18nMessages.buyNowBtnWrapper+data.id}
          >
            <div
              id={data.id}
              className={cardStyles.prodCardBtnDiv}
            >
              <BuyNowLiteComponent
                productShortName={data && data.title}
                gtinId={data && data.id}
                linkText={constants.buyNow}
                variant={variants}
                ratingData={ratingData}
                ratingCount={ratingCount}
                overallRatingRange={overallRatingRange}
              />
            </div>
          </div>
        </Card>
      </>
    );
  }
}

ProductCard.propTypes = {
  cardType: PropTypes.string,
  productData: PropTypes.oneOfType([PropTypes.object]).isRequired,
  locale: PropTypes.string.isRequired,
  indexKey: PropTypes.string.isRequired,
  indexNo: PropTypes.string,
  lazyLoad: PropTypes.bool
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const ProductCard = ({prop = val, cardType = 'productListing', indexNo = null, lazyLoad = false }) =>

export default withLocale(ProductCard);
